"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentShell = void 0;
const core_1 = require("@mantine/core");
const React = __importStar(require("react"));
const useStyles = (0, core_1.createStyles)((theme) => ({
    topSection: {
        paddingBottom: theme.spacing.md,
        paddingRight: theme.spacing.md,
        paddingLeft: theme.spacing.md,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        marginRight: -theme.spacing.md,
        marginLeft: -theme.spacing.md,
        marginBottom: theme.spacing.md,
        borderBottom: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
    },
    middleSection: {
        flex: 1
    },
    bottomSection: {
        paddingTop: theme.spacing.md,
        paddingRight: theme.spacing.md,
        paddingLeft: theme.spacing.md,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        marginTop: theme.spacing.md,
        marginRight: -theme.spacing.md,
        marginLeft: -theme.spacing.md,
        borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
    }
}));
//TODO: Should I make it a default props to be empty with minimum height?
function ContentShell(props) {
    const { classes } = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(core_1.Box, { className: classes.topSection }, props.topSection),
        React.createElement(core_1.ScrollArea, { offsetScrollbars: true, type: "auto", className: classes.middleSection }, props.children),
        React.createElement(core_1.Box, { className: classes.bottomSection }, props.bottomSection)));
}
exports.ContentShell = ContentShell;
//# sourceMappingURL=ContentShell.js.map